export const getManagementCompaniesPending = (state) => state.permissions.pending
